export enum TaskPlanningInvoicingStatusCode {
  toBill = 'to_bill',
  toBillOnDelivery = 'to_bill_on_delivery',
  billed = 'billed',
  na = 'na',
  billable = 'billable'
}
